import { render, staticRenderFns } from "./fillProductInfo.vue?vue&type=template&id=5dbd2d4f&scoped=true"
import script from "./fillProductInfo.vue?vue&type=script&lang=js"
export * from "./fillProductInfo.vue?vue&type=script&lang=js"
import style0 from "./fillProductInfo.vue?vue&type=style&index=0&id=5dbd2d4f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbd2d4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbd2d4f')) {
      api.createRecord('5dbd2d4f', component.options)
    } else {
      api.reload('5dbd2d4f', component.options)
    }
    module.hot.accept("./fillProductInfo.vue?vue&type=template&id=5dbd2d4f&scoped=true", function () {
      api.rerender('5dbd2d4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/children/fillProductInfo.vue"
export default component.exports